document.addEventListener("DOMContentLoaded", () => {
   const section = document.querySelector(".whatSetsApart");
   const progressRing = section?.querySelector(".whatSetsApart_ringProgress");
   const textItems = section ? Array.from(section.querySelectorAll(".whatSetsApart_item")) : [];

   if (!section || !progressRing || textItems.length < 2 || !window.gsap || !window.ScrollTrigger) {
      return;
   }

   gsap.registerPlugin(ScrollTrigger);

   const ringLength = progressRing.getTotalLength();
   progressRing.style.strokeDasharray = ringLength;
   progressRing.style.strokeDashoffset = ringLength;

   // ✅ Responsive offset
   const offsetX = () => {
      if (window.innerWidth < 767) {
         return Math.max(window.innerWidth * 0.95, 320);
      } else {
         return Math.max(window.innerWidth * 0.28, 160);
      }
   };

   const totalSteps = textItems.length - 1;

   gsap.set(textItems, { x: () => offsetX(), opacity: 0 });
   gsap.set(textItems[0], { x: 0, opacity: 1 });

   const timeline = gsap.timeline({
      defaults: { ease: "none" },
      scrollTrigger: {
         trigger: section,
         start: "50% 50%",
         end: () => `+=${window.innerHeight * (totalSteps + 0.6)}`,
         scrub: 1,
         pin: true,
         anticipatePin: 1,
         invalidateOnRefresh: true
      }
   });

   timeline.to(progressRing, {
      strokeDashoffset: 0,
      duration: totalSteps
   }, 0);

   for (let index = 0; index < totalSteps; index += 1) {
      timeline.to(textItems[index], {
         x: () => -offsetX(),
         opacity: 0,
         duration: 1
      }, index);

      timeline.fromTo(textItems[index + 1], {
         x: () => offsetX(),
         opacity: 0
      }, {
         x: 0,
         opacity: 1,
         duration: 1
      }, index);
   }

   // ✅ Refresh on resize
   window.addEventListener("resize", () => {
      ScrollTrigger.refresh();
   });
});
